var React = require('react');

function PlayerPause (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"#fff","d":"M39.7,83H24c-1.6,0-3-1.4-3-3V20c0-1.7,1.4-3,3-3h15.7c1.6,0,3,1.3,3,3V80C42.7,81.6,41.3,83,39.7,83z","key":0}),React.createElement("path",{"fill":"#fff","d":"M75.7,83H60.1c-1.7,0-3-1.4-3-3V20c0-1.7,1.3-3,3-3h15.7c1.7,0,3,1.3,3,3V80C78.7,81.6,77.4,83,75.7,83z","key":1})]));
}

PlayerPause.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 100 100","style":{"enableBackground":"new 0 0 100 100"},"xmlSpace":"preserve"};

module.exports = PlayerPause;

PlayerPause.default = PlayerPause;
